'use client'

import { useTranslation } from 'react-i18next'

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog'
import { ClubOfferForm } from './ClubOfferForm'

interface ClubOfferModalProps {
    storeId: string
    open: boolean
    /** When set, the modal edits this offer; otherwise it creates a new one. */
    offerId?: string | null
    onOpenChange: (open: boolean) => void
    onSaved?: () => void
}

export const ClubOfferModal = ({ storeId, open, offerId, onOpenChange, onSaved }: ClubOfferModalProps) => {
    const { t } = useTranslation('club')
    const isEdit = !!offerId

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="w-full sm:max-w-4xl">
                <DialogHeader>
                    <DialogTitle>{isEdit ? t('offers.modal.editTitle') : t('offers.modal.createTitle')}</DialogTitle>
                    <DialogDescription>{t('offers.modal.description')}</DialogDescription>
                </DialogHeader>

                {/* Remount on open/offer change so the form state resets cleanly. */}
                {open && (
                    <ClubOfferForm
                        key={offerId ?? 'new'}
                        storeId={storeId}
                        offerId={offerId}
                        onCancel={() => onOpenChange(false)}
                        onSaved={() => {
                            onOpenChange(false)
                            onSaved?.()
                        }}
                    />
                )}
            </DialogContent>
        </Dialog>
    )
}
